import { render, staticRenderFns } from "./TruncateText.vue?vue&type=template&id=389153f6&scoped=true"
import script from "./TruncateText.vue?vue&type=script&lang=js"
export * from "./TruncateText.vue?vue&type=script&lang=js"
import style0 from "./TruncateText.vue?vue&type=style&index=0&id=389153f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389153f6",
  null
  
)

export default component.exports